// == Temporal ==

// In minutes
export const HOUR_IN_MINUTES = 60
export const DAY_IN_MINUTES = 24 * HOUR_IN_MINUTES
export const YEAR_EST_IN_MINUTES = 365 * DAY_IN_MINUTES
export const FOREVER_IN_MINUTES = 1000 * YEAR_EST_IN_MINUTES

// In seconds
export const MINUTE_IN_SECONDS = 60

// In milliseconds
export const SECOND_IN_MS = 1000 // in milliseconds
export const MINUTE_IN_MS = MINUTE_IN_SECONDS * SECOND_IN_MS
export const HOUR_IN_MS = HOUR_IN_MINUTES * MINUTE_IN_MS

// == Binary measures ==

export const KIBI = 2 ** 10
export const MEBI = 2 ** 20
